import { DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface TrainingModuleDetailsProps {
  trainingModuleFormPayload: UseFormPayload,
  urls: {
    linkUrl?:string,
  },
}

const TrainingModuleDetails = (props: TrainingModuleDetailsProps) => {
  const { trainingModuleFormPayload, urls: { linkUrl } } = props

  const {
    entityState: {
      title,
      training_course_id,
    },
    errors,
    handlers,
  } = trainingModuleFormPayload

  return (
    <DashboardModule title="Training Module Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <EntitySelector
            // @ts-expect-error TS2739
            callbacks={{}}
            disabled
            endpoint="training_courses"
            entityKey="trainingCourses"
            goToHref={linkUrl}
            label="* Course"
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
            selectedItemId={training_course_id}
          />
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default TrainingModuleDetails
